// extracted by mini-css-extract-plugin
module.exports = {"basepage":"basepage-module--basepage--1StwG","basepage__nav":"basepage-module--basepage__nav--3DyNE"};